/* 任务状态 */
export const DAI_DIAO_DU = '01'
export const DAI_ZUO_YE = '02'
export const ZUO_YE_ZHONG = '03'
export const DAI_CHU_SHEN = '031'
export const DAI_ZHONG_SHEN = '04'
export const YI_WAN_CHENG = '05'
export const YI_QU_XIAO = '06'
export const QU_XIAO_ZHONG = '060'
export const QU_XIAO_ZHONG_CHU_SHEN = '061'
export const YI_GUAN_DAN = '07'
export const DAI_TIAO_JIE = '14'
export const TIAO_JIE_ZHONG = '15'
export const DAI_QUE_REN = '16'
export const YI_WAN_CHENG_WEI_TIAO_JIE = '170'
export const YI_WAN_CHENG_TIAO_JIE_SHI_BAI = '171'
export const YI_WAN_CHENG_TIAO_JIE_CHENG_GONG = '172'
// 诉讼待确认
export const DAI_QUE_REN_LAW = '011'
export const DAI_JIE_DAN = '012'

/* 任务类型 */
export const QI_TA_DIAO_CHA = '15'

export const ORDER_STATUS_DICT = {
	DAI_DIAO_DU,
	DAI_ZUO_YE,
	ZUO_YE_ZHONG,
	DAI_CHU_SHEN,
	DAI_ZHONG_SHEN,
	YI_WAN_CHENG,
	YI_QU_XIAO,
	QU_XIAO_ZHONG,
	QU_XIAO_ZHONG_CHU_SHEN,
	YI_GUAN_DAN,
	DAI_TIAO_JIE,
	TIAO_JIE_ZHONG,
	DAI_QUE_REN,
	YI_WAN_CHENG_WEI_TIAO_JIE,
	YI_WAN_CHENG_TIAO_JIE_SHI_BAI,
	YI_WAN_CHENG_TIAO_JIE_CHENG_GONG,
	// 诉讼待确认
	DAI_QUE_REN_LAW,
	DAI_JIE_DAN,
}
